import React, { useEffect, useState, createContext } from 'react'

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CardHeader from '@mui/material/CardHeader';

import { useLocation } from 'react-router-dom';

import SearchStringOrIntReq5 from "Classes/Models/Requests/SearchStringOrIntReq"
import SessionsApi from "../../../Classes/API/Administration/SessionsApi"

import EditSessionCard from "./EditSessionCard/index"
import DetailsCard from "./DetailsCard/index"
import SessionFacilityTypes from "./SessionFacilityTypes/index"
import SessionTherapistTypes from "./SessionTherapistTypes/index"
import SessionButtons from './SessionButtons';

const index = ({ }) => {

  const { state } = useLocation();
  const [Session, setSession] = useState({})
  const [ShowEdit, setShowEdit] = useState(false);
  const [IsLoaded, setIsLoaded] = useState(false)

  let req = new SearchStringOrIntReq5()

  useEffect(async () => {
    if (Object.keys(Session).length < 1 || !IsLoaded) {
      await GetSessionData(state.SearchSession.id)
    }

  }, [IsLoaded])

  useEffect(() => {

    if (Object.keys(Session).length > 0) {
      setIsLoaded(true);
    }
    else {
      setIsLoaded(false)
    }

  }, [Session])

  const GetSessionData = async (id) => {
    req.SearchInt = id;
    let res = await SessionsApi.GetSessionById(req)
    if (res.status == "Success") {
      // let metadataClone  = Object.assign({}, res.data)
      setSession(res.data)
    }
  }
  if (!IsLoaded) {
    return (<div>Loading...</div>)
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />

      {
        ShowEdit ? <EditSessionCard GetSessionData={GetSessionData} Session={Session}
          setShowEdit={setShowEdit} setIsLoaded={setIsLoaded} />
          : <DetailsCard Session={Session} setShowEdit={setShowEdit} />
      }
      <div className="container-fluid">
      <div className="row">
        <SessionFacilityTypes Session={Session} setIsLoaded={setIsLoaded} />
        <SessionTherapistTypes Session={Session} setIsLoaded={setIsLoaded} />
      </div>
      </div>
      {/* <SessionButtons /> */}
    </DashboardLayout>
  )
}

export default index